export type 商品区分型 = '医薬品' | 'その他品';
export const 商品区分一覧: 商品区分型[] = ['医薬品', 'その他品'];
